import RegistrationCounter from './RegistrationCounter';

export default RegistrationCounter;
